module.exports = __webpack_public_path__ + "img/tank.529c8dba.svg";